import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 17 14" {...this.props}><path fill="currentColor" d="M3.823 12.137L.288 8.602l1.414-1.415 3.536 3.536 9.9-9.9 1.413 1.415L5.238 13.55l-1.415-1.414z" /></svg>;
  }

}